import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@mantine/core';
import invokePromptConfirm from '@features/Prompt/PromptConfirm';

/**
 * Hook that provides a cancel confirmation prompt for upload cancellation
 * Extracted to keep the component clean and allow reuse
 */
export function useCancelConfirmation() {
  const { t } = useTranslation(['Resource', 'Common']);

  const showCancelConfirmation = useCallback(
    (onConfirm: () => void) => {
      invokePromptConfirm({
        title: t('Resource:ResourceUploadActivity.cancelConfirmTitle'),
        componentProps: {
          headless: true,
          closeImmediately: true,
          modalContent: (
            <Text ta="center" c="dimmed">
              {t('Resource:ResourceUploadActivity.cancelConfirmMessage')}
            </Text>
          ),
        },
        labels: {
          confirm: t('Common:prompts.confirm'),
          cancel: t('Common:prompts.cancel'),
        },
        onConfirm,
      });
    },
    [t],
  );

  return { showCancelConfirmation };
}
